export const css = {
    dark: '_24-O-Dg6',
    ' _key': 'afcpe-theme/afcpe/micro/mc-widgets/tools-button'
};
export default css;
